import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/(main)/zh/ZhDocumentLang.tsx");
